<template>
  <div>
      <div class="columns is-multiline">
          <div class="column is-5">
            <article class="message is-dark">
                <div class="message-body">
                    <div class="content">
                        <h5 class="title is-5 has-text-link"> <fa icon="award" class="fa-2x" /> <br> Pase VIP </h5>
                        <div class="has-text-justified">
                            <ul>
                                <li>Su costo es de {{numberFormat(costs.vip)}} créditos.</li>
                                <li>Tiene una duración de {{vip.days}} días.</li>
                                <li>Es individual por cada personaje.</li>
                            </ul>
                        </div>
                    </div>
                    <div class="content" v-if="loaded">
                        <h5 class="title is-5 has-text-grey">  Créditos </h5>
                        <p class="subtitle is-6 has-text-dark">{{numberFormat(credits)}}</p>
                    </div>
                    <fa v-else icon="circle-notch" class="fa-2x has-text-dark" spin /> 
                </div>
            </article>

            <article :class="['message', 'is-clipped', 'is-warning']">
            <div class="message-header" @click="profit=true">
                <p>Beneficios</p>
                <span class="icon"><fa icon="award" /></span>
            </div>
            </article>
          </div>
          <div class="column">
              <div class="table-container" v-if="loaded">
              <table class="table is-fullwidth">
                  <thead>
                      <tr class="has-text-justified">
                        <th>Nombre</th>
                        <th>Estado</th>
                        <th>Duración</th>
                        <th>Comprar</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="char in characters" :key="char.id" :class="{'has-text-justified':true, 'vip-back has-background-link-light':char.isvip>0}">
                          <td> <span class="icon" v-if="char.isvip>0"><fa icon="award" class="has-text-link" /></span> <b>{{char.name}}</b></td>
                          <td>
                              <span v-if="char.isvip > 0" class="has-text-success">Activo</span>
                              <span v-else>Inactivo</span>
                          </td>
                          <td>
                              <span v-if="char.isvip > 0">{{char.time.days}} días, {{char.time.hours}} horas y {{char.time.minutes}} minutos.</span>
                          </td>
                          <td width="10%" class="has-text-centered">
                              <a v-if="char.isvip==0" @click="buyVip(char)" class="tag is-link is-medium">
                                  <fa icon="plus-circle" />
                              </a>
                          </td>
                      </tr>
                  </tbody>
              </table>
              </div>
              <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin /> 
          </div>
      </div>
            <transition name="fade">
            <profit-modal v-if="profit"
            :show="profit"
            @close-modal="profit=false" />
            </transition>
  </div>
</template>

<script>
// import UserService from '@/services/user.service.js';
//import ExtraService from '@/services/extra.service.js'
import ProfitModal from '@/components/modals/vip.vue'
import Swal from 'sweetalert2'
export default {
    name:'DashboardVIPSection',
    props: ['user',],
    components: {
        ProfitModal
    },
    data:()=>({
        loaded:false,
        characters: [],
        modal: false,
        credits:0,
        creditsId:0,
        profit:false
    }),
    created() {
        this.$store.commit('changeDashboardPage', 4)
        this.setUpData()
    },
    computed: {
        dateTimeLeft() {
            return this.$store.getters.dateTimeLeft
        },
        costs() {
            return this.$store.getters.costs
        },
        addDaystoDate() {
            return this.$store.getters.addDaystoDate
        },
        dateToTimestamp() {
            return this.$store.getters.dateToTimestamp
        },
        numberFormat() {
            return this.$store.getters.numberWithCommas
        },
        vip() {
            return this.$store.getters.GetVipData
        }
    },
    methods: {
        async setUpData() {
            // const characters = await UserService.getCharacters(this.user.username)
            const characters = this.$store.getters.GetJson('dashboard-characters')
            this.makeCharacters(characters)
            
            const credits = this.$store.getters.GetJson('credits')
            this.credits = credits.credits
            this.creditsId = credits.id

            this.loaded=true
        },
        makeCharacters(data) {
            if(data.game1) this.characters.push({id:data.game1.id,name:data.game1.name, isvip:data.game1.isvip, timestamp: data.game1.vipexpirationtime, time:this.dateTimeLeft((new Date().setMonth(new Date().getMonth() + 12)))})
            if(data.game2) this.characters.push({id:data.game2.id,name:data.game2.name, isvip:data.game2.isvip, timestamp: data.game2.vipexpirationtime, time:this.dateTimeLeft((new Date().setMonth(new Date().getMonth() + 12)))})
            if(data.game3) this.characters.push({id:data.game3.id,name:data.game3.name, isvip:data.game3.isvip, timestamp: data.game3.vipexpirationtime, time:this.dateTimeLeft((new Date().setMonth(new Date().getMonth() + 12)))})
            if(data.game4) this.characters.push({id:data.game4.id,name:data.game4.name, isvip:data.game4.isvip, timestamp: data.game4.vipexpirationtime, time:this.dateTimeLeft((new Date().setMonth(new Date().getMonth() + 12)))})
            if(data.game5) this.characters.push({id:data.game5.id,name:data.game5.name, isvip:data.game5.isvip, timestamp: data.game5.vipexpirationtime, time:this.dateTimeLeft((new Date().setMonth(new Date().getMonth() + 12)))})
        },
        buyVip(char) {
            var message = ''
            if((this.credits - this.costs.vip) < 0) {
                message = `No tienes suficientes Créditos para comprar un pase VIP.`
                this.$toasted.show(message, { 
                    theme: 'toasted-danger', 
                    position: "top-center", 
                    duration : 5000
                });
                return
            }

            Swal.fire({
                title: '<strong>Comprar Pase <u>VIP</u></strong>',
                icon: 'info',
                html:
                    'Adquirir un pase VIP para <b>'+char.name+'</b>, <br>' +
                    'por un costo de '+this.numberFormat(this.costs.vip)+' créditos y una duración de '+this.vip.days+' días. <br><br>' +
                    '<div class="has-text-justified content"><ul><li>Si aceptas, a tu personaje se le otorgará un pase VIP con todos los beneficios. </li>' +
                    '<li>Te quedarán disponibles '+this.numberFormat(this.credits-this.costs.vip)+' créditos despues de adquirir el pase.</li></ul> </div>',
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText:
                    'Comprar!',
                cancelButtonText:
                    'Quizás luego.'
            }).then((result) => {
                if (result.value) {
                    // ExtraService.getServerTime()
                    //     .then(response => {
                    //         var expiration = this.dateToTimestamp(this.addDaystoDate(new Date(response.data), 7))
                            this.$store.commit('setLoader', true)

                            // UserService.updateCharacterVip(char.name, /*{isvip:1, vipexpirationtime:expiration}*/)
                            //     .then(response => {
                            //         var result = response.data
                            //         this.$store.commit('setLoader', false)
                            //         Swal.fire({
                            //             position: 'top',
                            //             icon: 'success',
                            //             title: 'Has adquirido satisfactoriamente un pase VIP para '+char.name+'!',
                            //             timer: 3500,
                            //             showConfirmButton: false,
                            //             showClass: {
                            //                 popup: 'animated fadeInDown faster'
                            //             },
                            //             hideClass: {
                            //                 popup: 'animated fadeOutUp faster'
                            //             }
                            //         }).then(() =>{
                            //             for (var c in this.characters) {
                            //                 if (this.characters[c].name === char.name){
                            //                     this.characters[c].isvip = result.isvip
                            //                     this.characters[c].vipexpirationtime = result.vipexpirationtime
                            //                     this.characters[c].time = this.dateTimeLeft(new Date(result.vipexpirationtime * 1000))
                            //                     break
                            //                 }
                            //             }
                            //             this.credits -= this.costs.vip
                            //         })
                                    
                            //     })
                            //     .catch(error=>{
                            //         message = error.response.data.info
                            //         this.$toasted.show(message, { 
                            //             theme: 'toasted-danger', 
                            //             position: "top-center", 
                            //             duration : 5000
                            //         });
                            //         this.$store.commit('setLoader', false)
                            //     })
                        // })
                                    Swal.fire({
                                        position: 'top',
                                        icon: 'success',
                                        title: 'Has adquirido satisfactoriamente un pase VIP para '+char.name+'!',
                                        timer: 3500,
                                        showConfirmButton: false,
                                        showClass: {
                                            popup: 'animated fadeInDown faster'
                                        },
                                        hideClass: {
                                            popup: 'animated fadeOutUp faster'
                                        }
                                    }).then(() =>{
                                        for (var c in this.characters) {
                                            if (this.characters[c].name === char.name){
                                                this.characters[c].isvip = true
                                                this.characters[c].vipexpirationtime = 1597470820
                                                this.characters[c].time = this.dateTimeLeft((new Date().setMonth(new Date().getMonth() + 12)))
                                                break
                                            }
                                        }
                                        this.credits -= this.costs.vip
                                        this.$store.commit('setLoader', false)
                                    })                        
                }
            })

        }
    }
}
</script>

<style scoped>
    .message-header { cursor: pointer;}
</style>